<template>
    <video
        class="th-video"
        autoplay
        playsinline
        :loop
        muted
        :src="video.uri"
        :type="video.type"
    />
</template>

<script setup lang="ts">
import type { CatalogueVideo } from '@/graphql/api'

withDefaults(
    defineProps<{
        video: CatalogueVideo
        loop?: boolean
    }>(),
    {
        loop: true,
    }
)
</script>

<style scoped lang="scss">
.th-video {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center;
}
</style>
